import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    produits: [
      { href: '/produits/gloovy', label: 'Gloovy' },
      { href: '/produits', label: 'Tous les produits' },
    ],
    entreprise: [
      { href: '/a-propos', label: 'À propos' },
      { href: '/journal', label: 'Journal' },
      { href: '/avis', label: 'Avis clients' },
    ],
    legal: [
      { href: '/cgv', label: 'CGV' },
      { href: '/politique-retour', label: 'Politique de retour' },
      { href: '/livraison', label: 'Livraison' },
      { href: '/contact', label: 'Contact' },
    ],
  };

  return (
    <footer className="bg-ghrb-black text-white relative grain-overlay">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 mb-16">
          {/* Brand */}
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block mb-6" data-testid="footer-logo">
              <span className="font-outfit text-3xl font-bold tracking-tighter">
                GHRB
              </span>
            </Link>
            <p className="font-jakarta text-white/60 text-base leading-relaxed max-w-sm">
              L'efficacité, sans compromis. Des produits simples pour des résultats visibles.
            </p>
          </div>

          {/* Links */}
          <div className="lg:col-span-8 grid grid-cols-2 md:grid-cols-3 gap-8">
            <div>
              <h4 className="font-outfit text-xs uppercase tracking-[0.2em] text-white/40 mb-4">
                Produits
              </h4>
              <ul className="space-y-3">
                {footerLinks.produits.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="font-jakarta text-sm text-white/80 hover:text-ghrb-orange transition-colors footer-link"
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-outfit text-xs uppercase tracking-[0.2em] text-white/40 mb-4">
                Entreprise
              </h4>
              <ul className="space-y-3">
                {footerLinks.entreprise.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="font-jakarta text-sm text-white/80 hover:text-ghrb-orange transition-colors footer-link"
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-outfit text-xs uppercase tracking-[0.2em] text-white/40 mb-4">
                Informations
              </h4>
              <ul className="space-y-3">
                {footerLinks.legal.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="font-jakarta text-sm text-white/80 hover:text-ghrb-orange transition-colors footer-link"
                      data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-jakarta text-sm text-white/40">
              © {currentYear} GHRB. Tous droits réservés.
            </p>
            <div className="flex items-center gap-6">
              <span className="font-jakarta text-sm text-white/40">
                Paiement sécurisé par Stripe
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
